<template>
  <div
      class="container"
      :style="{ backgroundImage: 'url(' + live.phoneBackUrl + ')' }"
  >
    <Chat/>
    <SvgPlayer/>
    <Sign @onSuccess="onSignSuccess"/>
    <SignInModal
        ref="signInModal"
        @signed="handleSignSuccess"
        @close="handleModalClose"/>
    <GiftMenu ref="giftMenuRef"/>
    <EnterLive/>
    <WinNotice/>
    <Notice @onOpenMsg=""/>
    <LiveNotice/>
    <RechargeNotice/>
    <CoolNotification ref="notifier"/>
    <UnReadMsgPopup :show.sync="showMsgPopup"
                    :initial-messages="msgList"/>
    <WeatherEffects :weatherData="weatherData"
                    :loop="true"
                    :showIndicator="true"/>
    <Fireworks ref="fireRef"/>
    <!-- ✅ 新增：生日活动礼物广告（半透明，点击进商品详情） -->
    <GiftAdPopup ref="giftAd" @tapped="onAdTapped" @closed="onAdClosed"/>
    <!-- ✅ 新增：商品详情弹窗（广告点击后打开） -->
    <GoodsPopup ref="giftGoodsPopup"/>
    <LuckyGiftWheel/>
  </div>
</template>
<script>
import CoolNotification from "@views/home/model/notice/CoolNotification";
import RechargeNotice from "@views/home/model/notice/RechargeNotice";
import LiveNotice from "@views/home/model/notice/LiveNotice";
import Chat from "@views/home/model/Chat";
import SvgPlayer from "@views/home/model/SvgPlayer";
import Sign from "@views/home/model/Sign";
import GiftMenu from "@views/home/model/GiftMenu";
import EnterLive from "@views/home/model/EnterLive";
import WinNotice from "@views/home/model/notice/WinNotice";
import Notice from "@views/home/model/notice/Notice";
import UnReadMsgPopup from "@views/home/model/popup/UnReadMsgPopup";
import {mapGetters, mapState} from "vuex";
import WeatherEffects from "@views/home/model/WeatherEffects";
import SignInModal from "@views/home/model/popup/SignInModal";
import Fireworks from "@/components/Fireworks"
import GiftAdPopup from "@views/home/model/popup/GiftAdPopup";
import GoodsPopup from "@views/home/model/popup/GoodsPopup";
import {getRandom} from "@utils";
import DOMPurify from "dompurify";
import {_code} from "@utils/constant";
import LuckyGiftWheel from "@views/home/model/popup/LuckyGiftWheel.vue";

export default {
  name: "Index",
  components: {
    LuckyGiftWheel,
    Fireworks,
    WeatherEffects,
    UnReadMsgPopup,
    CoolNotification,
    RechargeNotice,
    GiftMenu,
    Sign,
    SvgPlayer,
    Chat,
    EnterLive,
    WinNotice,
    Notice,
    LiveNotice,
    SignInModal,
    GiftAdPopup,  // ✅ 新增
    GoodsPopup    // ✅ 新增
  },
  computed: {
    ...mapGetters(["live"])
  },
  mounted() {
    this.fireWork();
    this.$Bus.$on("openUnReadMsg", (msg) => {
      this.showMsgPopup = true;
      this.msgList = msg;
    });
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);

    // ✅ 新增：生日活动，页面稳定后弹出随机礼物广告
    this.showRandomGiftTimer = setTimeout(() => {
      this.showRandomGift();
    }, 3000);
  },
  data() {
    return {
      weatherData: {
        type: 'rainy',
        temp: 28
      },
      showMsgPopup: false,
      msgList: [],
      fireTimer: null,
      // ✅ 新增：礼物广告相关
      showRandomGiftTimer: null,   // 首次弹出定时器
      adReplayTimer: null,         // 关闭后再次弹出的定时器
      giftProductIds: [
        'fcbb6617586e9cc75d98388a0968643d',  // 蛋糕
        // '这里换成鲜花商品ID',
        // '这里换成游戏机商品ID',
        // '这里换成用户点ID',
      ]
    }
  },
  activated() {
    this.initCheckActSign(); // 移至此处，每次进入页面都执行
  },
  methods: {
    // ✅ 新增：生日活动随机弹出一个礼物「广告」
    showRandomGift() {
      // 非生日活动不弹
      if (!['birthday'].includes(this.live.liveTypeCode)) return;
      // 商品池为空不弹
      if (!this.giftProductIds.length) return;
      // 广告已开着不重复弹
      if (this.$refs.giftAd && this.$refs.giftAd.visible) return;

      const randomId = this.giftProductIds[Math.floor(Math.random() * this.giftProductIds.length)];
      this.$refs.giftAd.open(randomId);
    },

    // ✅ 新增：用户点了广告 → 打开商品详情弹窗
    onAdTapped(productId) {
      this.$refs.giftGoodsPopup.open(productId);
    },

    // ✅ 新增：用户关掉广告 → 20 秒后随机再推一次（不想要就删掉 setTimeout 内容）
    onAdClosed() {
      if (this.adReplayTimer) clearTimeout(this.adReplayTimer);
      this.adReplayTimer = setTimeout(() => {
        this.showRandomGift();
      }, 20000);
    },

    onSignSuccess(){
      // if(this.live.id==='1740a7c47acf19c877f27f88bfde2260'){
      //   this.$refs.giftMenuRef.openDraw();
      // }
    },
    handleSocketMessage(msg) {
      switch (msg.msgType) {
        case _code.SEND_CARD: // 发送名片
          if (this.live.id === msg.liveId) {
            let jsonData = JSON.parse(msg.data);
            this.$refs.notifier.showCard(
                msg.nickname,
                msg.avatar,
                jsonData.position,
                jsonData.company
            )
          }
          break;
        case _code.SEND_PIC: // 发送图片
          if (this.live.id === msg.liveId) {
            this.$refs.notifier.showPhoto(
                msg.nickname,
                msg.avatar,
                "敬请鉴赏！"
            )
          }
          break;
        case _code.SEND_RED_PACKET: // 发红包
          if (this.live.id === msg.liveId) {
            let jsonData = JSON.parse(msg.data);
            this.$refs.notifier.showRedPacket(
                msg.nickname,
                msg.avatar,
                jsonData.wish
            )
          }
          break;
        case _code.SEND_RESOURCE: // 发资源
          if (this.live.id === msg.liveId) {
            let jsonData = JSON.parse(msg.data);
            this.$refs.notifier.showResource(
                msg.nickname,
                msg.avatar,
                jsonData.name
            )
          }
          break;
        case _code.SEND_WISH: // 发祝福
          if (this.live.id === msg.liveId) {
            this.$refs.notifier.showWish(
                msg.nickname,
                msg.avatar,
                msg.data
            )
          }
          break;
        case _code.SEND_GIFT: // 发送礼物
          let jsonData = JSON.parse(msg.data);
          if (this.live.id === msg.liveId) {
            this.$refs.notifier.showGift(
                msg.nickname,
                msg.avatar,
                jsonData.giftName,
                jsonData.coverUrl
            )
          }
          break;
        case _code.SIGN: // 签到
          if (this.live.id === msg.liveId) {
            this.$refs.notifier.showSign(
                msg.nickname,
                msg.avatar,
                "欢迎加入！！"
            )
          }
          break;
      }
    },
    // 处理签到成功事件
    handleSignSuccess(streakDays) {
      console.log(`签到成功，当前连续签到${streakDays}天`);
      // 这里可以添加签到成功后的其他逻辑，如更新用户积分等
    },
    // 处理弹窗关闭事件
    handleModalClose() {
      console.log('签到弹窗已关闭');
    },
    initCheckActSign() {
      this.$http.get("/signAct/checkSign", {params: {id: this.live.id}},).then(res => {
        if (!res.data) {
          this.$refs.signInModal.open();
        }
      })
    },
    fireWork() {
      this.$refs.fireRef.toggleDayMode();
      this.$refs.fireRef.triggerFirework();
      if (this.fireTimer) {
        clearTimeout(this.fireTimer);
      }
      const next = getRandom(3, 6) * 1000;
      this.fireTimer = setTimeout(() => {
        this.$refs.fireRef.toggleDayMode();
        this.fireWork();
      }, next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.fireTimer);
    // ✅ 新增：清理礼物广告定时器
    clearTimeout(this.showRandomGiftTimer);
    clearTimeout(this.adReplayTimer);
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
  }
}
</script>
<style>
body {
  padding-right: 0px !important;
  overflow: hidden;
}

.container {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-position: center;
}
</style>
